import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const Document = ({name, onChange}) => {
    const inputRef = useRef();
    const { t } = useTranslation("common");
    
        return (
            <div className="main-content__upload-field">
                <div className="main-content__upload-field-wrap">
                    <div className="main-content__upload-box" onClick={() => { inputRef?.current?.click() }}>
                        <div className="main-content__upload-box-text">
                            <i className="fa-light fa-file-image"></i>
                            <div id="uploadText">{t("uploadDocument")}</div>
                            <div>
                                <br /> <span>{t("browse")}</span>
                            </div>
                        </div>
                        <input type="file" name={name} ref={inputRef} hidden onChange={onChange} />
                    </div>
                </div>
            </div>
        )
};

export default Document;
